"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.successIcon = exports.errorIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var errorIcon = '/static/images/attention.svg';
exports.errorIcon = errorIcon;
var successIcon = '/static/images/checkmark.svg';
exports.successIcon = successIcon;